<div>
  <ng-container *ngIf="isLoading; then loading; else loaded"></ng-container>

  <ng-template #loading>
    <div class="spinner-grow text-primary load m-5" role="status" data-test-id="loading-spinner">
      <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
    </div>
  </ng-template>

  <ng-template #loaded>
    <div>
      <h1 class="my-3 search-result" [innerHtml]="searchResultHint"></h1>
      <div *ngIf="results.length">
        <div ngbDropdown class="d-inline-block pb-3">
          <button ngbDropdownToggle data-test-id="sortBy-opener" type="button" class="sort-btn">
            {{ 'SORT_BY_TITLE' | translate }} {{ selectedSearchOption | translate }}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownMenuSorting">
            <ng-container *ngFor="let item of sortOptions; index as i">
              <button
                type="button"
                [attr.data-test-id]="'sort-option-' + i"
                ngbDropdownItem
                (click)="selectOption(item)"
              >
                {{ item | translate }}
              </button>
            </ng-container>
          </div>
        </div>
        <ng-content select="[search-pagination]"></ng-content>
        <div class="row">
          <ng-content select="[search-results]"></ng-content>
        </div>
      </div>
    </div>
  </ng-template>
</div>
